export const FETCH_GIS_SETTINGS_REQUEST =
  'gisSettings/FETCH_GIS_SETTINGS_REQUEST'
export const FETCH_GIS_SETTINGS_SUCCESS =
  'gisSettings/FETCH_GIS_SETTINGS_SUCCESS'
export const FETCH_GIS_SETTINGS_FAILURE =
  'gisSettings/FETCH_GIS_SETTINGS_FAILURE'

export const UPDATE_GIS_SETTINGS_REQUEST =
  'gisSettings/UPDATE_GIS_SETTINGS_REQUEST'
export const UPDATE_GIS_SETTINGS_SUCCESS =
  'gisSettings/UPDATE_GIS_SETTINGS_SUCCESS'
export const UPDATE_GIS_SETTINGS_FAILURE =
  'gisSettings/UPDATE_GIS_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'gisSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'gisSettings/SET_DEFAULT_DATA'
